import { NgTableComponent } from './components/table/ng-table.component';

import { NgTableFilteringDirective } from './components/table/ng-table-filtering.directive';
import { NgTablePagingDirective } from './components/table/ng-table-paging.directive';
import { NgTableSortingDirective } from './components/table/ng-table-sorting.directive';

export * from './components/table/ng-table.component';

export * from './components/table/ng-table-filtering.directive';
export * from './components/table/ng-table-paging.directive';
export * from './components/table/ng-table-sorting.directive';

export * from './components/ng-table-directives';

export default {
  directives: [
    NgTableComponent,
    NgTableFilteringDirective,
    NgTableSortingDirective,
    NgTablePagingDirective
  ]
};

export { Ng2TableModule } from './components/ng-table-module';



// WEBPACK FOOTER //
// ./~/ng2-table/ng2-table.ts